import styled from 'styled-components';
import { SOURCES_TYPES } from '@/common/enums/source-types.enum';
import TopTitleHeader from '@/common/components/TopTitleHeader';
import { useLanguageData } from '@/common/hooks/useLanguageData';

const TopWrapper = styled.div`
	border-bottom: 1px solid #d9d9d9;
	display: flex;
	width: 100%;
	justify-content: space-between;
	align-items: center;

	@media (max-width: 600px) {
		flex-direction: column;
		border: none;
	}
`;

const FlashcardView = ({ data, background, newImage }) => {
	const { title } = useLanguageData('features.fotoMode.welcome');

	return (
		<TopWrapper>
			<TopTitleHeader
				title={title}
				navigate={`/learn`}
				source={SOURCES_TYPES.IMAGE_MODE}
				showHands={true}
				background={background}
				newImage={newImage}
			/>
		</TopWrapper>
	);
};

export default FlashcardView;
